import type { CityConfig } from "../city-template/types";

export const findlayConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Findlay",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "findlay",
  route: "/findlay",
  title: "Emergency Passport Findlay, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Findlay, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Hancock County and northwest Ohio. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Findlay, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport in Findlay? We help Hancock County and northwest Ohio travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Findlay%20Ohio%20downtown%20main%20street%20view%20with%20historic%20buildings%20and%20Hancock%20County%20courthouse%2C%20small%20city%20charm%20with%20brick%20architecture%2C%20green%20trees%20and%20sunny%20sky%2C%20warm%20afternoon%20light%20with%20clear%20blue%20sky%2C%20professional%20northwest%20Ohio%20cityscape%20photography%20with%20vibrant%20colors&width=1800&height=700&seq=findlay-oh-hero-001&orientation=landscape",
  heroImageAlt: "Findlay Ohio downtown main street with historic buildings and Hancock County courthouse",
  geoPosition: "41.0442;-83.6499",
  geoPlacename: "Findlay, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 250 miles from Findlay via I-80",
  },
  nearbyCitiesZips: [
    { name: "Findlay", zips: "45839, 45840" },
    { name: "Bowling Green", zips: "43402, 43403" },
    { name: "Fostoria", zips: "44830" },
    { name: "Lima", zips: "45801–45807" },
    { name: "Tiffin", zips: "44883" },
    { name: "Toledo", zips: "43601–43625" },
    { name: "Perrysburg", zips: "43551, 43552" },
    { name: "Defiance", zips: "43512" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Findlay departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Hancock County Coverage", desc: "Serving Findlay, Bowling Green, and northwest Ohio" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Toledo, OH", route: "/toledo" },
    { name: "Fast passport renewal in Columbus, OH", route: "/columbus-oh" },
    { name: "Emergency passport help in Dayton, OH", route: "/dayton" },
    { name: "Urgent passport services in Cleveland, OH", route: "/cleveland" },
    { name: "Same-day passport help in Cincinnati, OH", route: "/cincinnati" },
    { name: "Passport courier services in Springfield, OH", route: "/springfield-oh" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Findlay remotely via secure courier. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, achieving 24–48 hour turnaround for Hancock County travelers.",
  fpcOfficeDistance: "Serving all of Hancock County and northwest Ohio",
  fpcOfficeAddress: "1330 Carnegie Ave, Cleveland, OH 44115",
  serviceAreaIntro: "From downtown Findlay to the surrounding Hancock County communities, Fast Passport Center serves northwest Ohio travelers.",
  nearbyCitiesIntro: "We serve Findlay and nearby communities including Bowling Green, Fostoria, Lima, Tiffin, Toledo, Perrysburg, and Defiance.",
  howItWorksIntro: "Most northwest Ohio travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Findlay travelers often face a long drive to the Chicago Regional Passport Agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Hancock County and northwest Ohio travelers trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Findlay? Here are the most common ones we hear from Hancock County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  vitalRecordsLinks: [
    { icon: "ri-user-heart-line", label: "Birth Certificates — Ohio Department of Health", desc: "Request certified Ohio birth certificates from the ODH Bureau of Vital Statistics. Available by mail, online, or in person at the Columbus office.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-file-history-line", label: "Death Certificates — Ohio Department of Health", desc: "Obtain certified Ohio death certificates through ODH Vital Statistics. Mail, online, and in-person options available.", url: "https://odh.ohio.gov/know-our-programs/vital-statistics" },
    { icon: "ri-hearts-line", label: "Marriage Certificates — Hancock County Probate Court", desc: "Marriage licenses and certified copies available through the Hancock County Probate Judge at 300 S Main St, Findlay, OH 45840.", url: "https://www.hancockcountyohio.gov/probate-court" },
    { icon: "ri-file-copy-2-line", label: "Divorce Records — Hancock County Clerk of Courts", desc: "Certified divorce decrees available from the Hancock County Clerk of Courts at 300 S Main St, Findlay, OH 45840.", url: "https://www.hancockcountyohio.gov/clerk-of-courts" },
    { icon: "ri-global-line", label: "Order Online — VitalChek", desc: "Order Ohio birth, death, marriage, and divorce certificates online through VitalChek, the official partner of the Ohio Department of Health. Fastest online option.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail",
        "Can't upgrade speed after submission",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Findlay international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
    { name: "New Passport", description: "First-time passport application assistance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports." },
    { name: "Child Passport", description: "Passport services for minors under 16." },
    { name: "Name Change", description: "Passport correction and name change service." },
  ],
  testimonials: [
    {
      name: "Paul R.",
      location: "Findlay, OH",
      rating: 5,
      text: "Had a passport emergency 3 days before my business trip to Europe. Fast Passport Center got it done in 48 hours. Truly impressive service.",
      service: "Emergency Passport",
    },
    {
      name: "Susan B.",
      location: "Bowling Green, OH",
      rating: 5,
      text: "Renewed my passport for our family trip to Mexico. Fast Passport Center had it ready in 4 days. They were professional and responsive.",
      service: "Passport Renewal",
    },
    {
      name: "Mike T.",
      location: "Fostoria, OH",
      rating: 5,
      text: "Last-minute wedding trip to Jamaica. Fast Passport Center handled my emergency passport in 36 hours. No drive to Chicago required!",
      service: "Emergency Passport",
    },
    {
      name: "Nancy K.",
      location: "Lima, OH",
      rating: 5,
      text: "First-time passport for my son. Fast Passport Center found the nearest acceptance facility and got it done in 5 days. Highly recommend.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "findlay-1",
      name: "Findlay Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "222 W Main Cross St",
      city: "Findlay",
      state: "OH",
      zip: "45840",
      phone: "(419) 422-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Findlay",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main Findlay facility. Call ahead for passport appointments.",
      icon: "ri-mail-line",
    },
    {
      id: "findlay-2",
      name: "Bowling Green Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "141 E Wooster St",
      city: "Bowling Green",
      state: "OH",
      zip: "43402",
      phone: "(419) 352-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Findlay",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bowling Green and Wood County residents. Ample parking.",
      icon: "ri-mail-line",
    },
    {
      id: "findlay-3",
      name: "Fostoria Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 S Main St",
      city: "Fostoria",
      state: "OH",
      zip: "44830",
      phone: "(419) 435-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles northeast of Findlay",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for northeast Hancock County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "findlay-4",
      name: "Hancock County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "300 S Main St",
      city: "Findlay",
      state: "OH",
      zip: "45840",
      phone: "(419) 424-7067",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Hancock County Courthouse",
      website: "https://www.hancockcountyohio.gov/",
      websiteLabel: "Hancock County",
      notes: "Accepts passport applications. Good alternative to post office.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Passport photos must be exactly 2×2 inches with a white or off-white background. Many local photo shops use wrong specs.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hancock County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many applicants show up with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "For minors, both parents must appear or submit notarized consent. Don't miss this requirement.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop documents at any UPS location in Findlay." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Findlay address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Findlay before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Findlay for travelers with urgent international flights. Our registered couriers achieve 24–48 hour turnaround without the 4+ hour drive to Chicago." },
    { q: "How fast can I renew my passport in Findlay?", a: "We offer fast passport renewal in Findlay in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What is the closest passport agency to Findlay, OH?", a: "The nearest regional passport agency to Findlay is the Chicago Passport Agency, approximately 250 miles away. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround." },
    { q: "Do I need to drive to Chicago for an emergency passport?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities." },
    { q: "Can I expedite a child passport in Findlay?", a: "Yes. We expedite child passports in Findlay for minors under 16. Both parents must appear or submit notarized consent." },
    { q: "What should I do if I lost my passport before a trip?", a: "Contact Fast Passport Center immediately. We provide lost passport replacement services in Findlay with DS-64 form guidance. Our emergency courier service can get your replacement in 24–48 hours." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Findlay", address: "2123 Tiffin Ave, Findlay, OH 45840", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Findlay", address: "1031 Trenton Ave, Findlay, OH 45840", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart Supercenter — Findlay", address: "2500 Tiffin Ave, Findlay, OH 45840", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "FedEx Office — Findlay", address: "1810 S Main St, Findlay, OH 45840", hours: "Mon–Fri: 8AM–8PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    {
      name: "Hancock County BMV — Findlay",
      address: "109 E Crawford St, Findlay, OH 45840",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Bowling Green BMV Deputy Registrar",
      address: "1031 E Wooster St, Bowling Green, OH 43402",
      hours: "Mon–Fri: 9AM–5PM",
      note: "Alternative for Wood County residents. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "TOL",
      name: "Toledo Express Airport",
      distance: "45 miles north of Findlay",
      address: "11013 Airport Hwy, Swanton, OH 43558",
      note: "Nearest airport for Findlay. Domestic flights to major hubs.",
      flightUrl: "https://www.toledoexpress.com/",
      flightLabel: "Toledo Express Airport",
      featured: true,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "90 miles south of Findlay",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Alternative with more domestic routes.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "110 miles northeast of Findlay",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Major hub with international routes. Consider for long-haul trips.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
  ],
};